import { useState } from "react";
import {
  Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger,
} from "@/components/ui/dialog";
import { ContactForm } from "@/components/ContactForm";

/**
 * Reusable lead dialog. Wrap any trigger element.
 */
export const LeadDialog = ({
  trigger,
  title = "Get Medical Support",
  description = "Tell us what you need — our coordinator will reply as soon as possible.",
  defaultType = "medical",
  presetService = "",
  source = "cta",
}) => {
  const [open, setOpen] = useState(false);
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>{trigger}</DialogTrigger>
      <DialogContent className="max-h-[92vh] overflow-y-auto sm:max-w-lg" data-testid="lead-dialog">
        <DialogHeader>
          <DialogTitle className="text-2xl font-extrabold text-[hsl(var(--vc-ink))]">{title}</DialogTitle>
          <DialogDescription className="text-[hsl(var(--vc-slate))]">{description}</DialogDescription>
        </DialogHeader>
        <ContactForm defaultType={defaultType} presetService={presetService} source={source} />
      </DialogContent>
    </Dialog>
  );
};

export default LeadDialog;
